import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/svgs/Diamond.svg';
import _imports_1 from '@/assets/svgs/save.svg';
import _imports_2 from '@/assets/svgs/checked.svg';
const _hoisted_1 = {
  class: "membership-privilege"
};
const _hoisted_2 = {
  class: "membership-header"
};
const _hoisted_3 = {
  class: "membership-title"
};
const _hoisted_4 = {
  class: "membership-price"
};
const _hoisted_5 = {
  class: "price-main"
};
const _hoisted_6 = {
  class: "price-year"
};
const _hoisted_7 = {
  class: "price-origin"
};
const _hoisted_8 = {
  class: "membership-save"
};
const _hoisted_9 = {
  class: "save-badge"
};
const _hoisted_10 = {
  class: "privilege-list"
};
import { computed } from "vue";
export default {
  __name: 'membership-privilege',
  props: {
    productInfo: {
      type: Object,
      default: () => ({})
    }
  },
  setup(__props) {
    const props = __props;
    const safeProductInfo = computed(() => props.productInfo || {});
    const {
      name = "",
      currency = "$",
      price = 0,
      unit = "mo",
      originalPrice = 0,
      save = 0,
      memberBenefits = []
    } = safeProductInfo.value;
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[0] || (_cache[0] = _createElementVNode("img", {
        src: _imports_0,
        alt: "Diamond Membership",
        class: "membership-icon"
      }, null, -1)), _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(name)), 1)]), _createElementVNode("div", _hoisted_4, [_createElementVNode("span", _hoisted_5, _toDisplayString(_unref(currency)) + _toDisplayString(_unref(price)), 1), _createElementVNode("span", _hoisted_6, "/" + _toDisplayString(_unref(unit)), 1), _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(currency)) + _toDisplayString(_unref(originalPrice)) + "/" + _toDisplayString(_unref(unit)), 1)]), _createElementVNode("div", _hoisted_8, [_cache[1] || (_cache[1] = _createElementVNode("img", {
        src: _imports_1,
        alt: "save",
        class: "save-icon"
      }, null, -1)), _createElementVNode("span", _hoisted_9, "Save " + _toDisplayString(_unref(currency)) + _toDisplayString(_unref(save)), 1)]), _createElementVNode("ul", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(memberBenefits), item => {
        return _openBlock(), _createElementBlock("li", {
          key: item,
          class: "privilege-item"
        }, [_createElementVNode("span", null, _toDisplayString(item), 1), _cache[2] || (_cache[2] = _createElementVNode("img", {
          src: _imports_2,
          alt: "check",
          class: "check-icon"
        }, null, -1))]);
      }), 128))])]);
    };
  }
};